import { extensions } from 'mime-types';

import { MediaRulesByType } from 'modules/refData/types/RefData';

import { MediaSupport } from '../../types/mediaTypes';

export const getMergedMediaSupport = (mediaRules: MediaRulesByType) => {
  const supportedTypes = Object.values(mediaRules ?? {}).reduce((allSupportedTypes, mediaRule) => {
    // We need to clean the supported types to avoid empty and padded strings
    const cleanedSupportedTypes = mediaRule['supported-types'].split(',').reduce((currentSupportedTypes, supportedType) => {
      if (supportedType) {
        currentSupportedTypes.add(supportedType.trim());
      }

      return currentSupportedTypes;
    }, new Set<string>());

    cleanedSupportedTypes.forEach((supportedType) => allSupportedTypes.add(supportedType)); // Merge the two sets
    return allSupportedTypes;
  }, new Set<string>()); // We use sets to ensure types are included only once

  const types = Array.from(supportedTypes);

  return {
    types,
    extensions: types.flatMap((type) => extensions[type]?.map((ext) => `.${ext}`) ?? []),
  } as MediaSupport;
};
